import { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import { t } from "i18next";

import { InformationPanelUser } from "@/shared/components/organisms/InformationPanelUser";
import { Modal } from "@/shared/components/organisms/Modal";

// Stripe
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// APIS
import {
  useUserQuery,
  useUserGetQuery,
  useUpdateSetUserMutation,
  useFirmaContracMutation,
  useStateUserMutation,
  useUpdatePassMutation,
  useWebAppMutation,
  useCreateTagMutation,
  useGetEarningsMonthQuery,
  useGetTicketMutation,
  useTagMarketingQuery,
  useGetAverageLifeQuery,
  useGetTransactionsQuery,
  useGetpaymentMethodsQuery,
  useUserDeleteMutation,
} from "@/app/users/users.api";

import { useLazyStripeSetupIntentQuery } from "@/app/payments/payments.api";

import CardsGestion from "@/shared/components/organisms/CardsGestion";
import { Select } from "@/shared/components/organisms/Select";
import { TabsUser } from "@/shared/components/organisms/TabsUser";
import CustomerExperiencie from "./CustomerExperiencie";

// Components
import LoyaltyUser from "./LoyaltyUser";
import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5xy from "@amcharts/amcharts5/xy";

// Views
import { AssistedsAssignment } from "../Views/AssistedsAssignment";
import { LessonsAssignment } from "../Views/LessonsAssignment";
import { CoursesAssignment } from "../Views/CoursesAssignment";
import { SlotsAssignment } from "../Views/SlotsAssignment";
import { StoreAssignment } from "../Views/StoreAssignment";
import { FeesAssignment } from "../Views/FeesAssignment";

// APIS
import { useSlotsUserQuery } from "@/app/slots/slots.api";
import { useGetAllStatesQuery } from "@/app/app.apiStates";
import { useRolesQuery } from "@/app/roles/roles.api";
import { useGetAllCountriesQuery } from "@/app/app.apiCountry";
import { useGymsByAccessUserQuery } from "@/app/gyms/gyms.api";
import { useFetchBranchsMutation } from "@/app/branchs/branchs.api";

// Utils
import { formatDateTime } from "@/shared/utils/formatedDate";
import { faAt, faPhone } from "@fortawesome/pro-regular-svg-icons";
import { Eye, EyeOff, LogIn, FileText, DollarSign, Clock } from "lucide-react";
import * as Yup from "yup";
import {
  colorsKpi,
  configureExporting,
  initializeAmChart,
  Language,
  months,
} from "@/shared/utils/chartUtils";

import {
  userInitialValues,
  userValidationSchema,
} from "@/shared/schemas/users.schema";

import { InputWithLeadingIcon } from "@/shared/components/atoms/InputWithLeadingIcon";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { SelectCountry } from "@/shared/components/organisms/SelectCountry";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { InputFile } from "@/shared/components/atoms/InputFile";
import { toasts } from "@/shared/utils/toasts";

import { Formik, useFormik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Branch } from "@/app/branchs/branchs.type";
import { selectUser } from "@/app/auth/auth.slice";
import { DOMAIN } from "@/app/app.api";
import TableListCuotasCursosUsers from "@/shared/components/organisms/TableListCuotasCursosUsers";
import { ButtonSoft } from "@/shared/components/atoms/ButtonSoft";
import { TableListCursosUsers } from "@/shared/components/organisms/TableListCursosUsers";
import { ListHistorial } from "@/shared/components/organisms/ListHistorial";
import ListChatUser from "@/shared/components/organisms/ListChatUser";

interface UserContentProps {
  OptionsBrandedActiveSP: any;
  handleOpenDialogAssingBond: () => void;
  handleOpenDialogEditBond: () => void;
  OptionsBrandedActiveFeeCursos: any;
  setFormsCourses: any;
  itemsChat: any;
  handleOpenDialogCourses: () => void;
  setTitleDialogMethodsPay: (value: string) => void;
  handleOpenDialogAsingLessons: (event: any) => void;
  handleOpenDialogAsingAssisteds: (event: any) => void;
}

const toSnakeCase = (obj: any) => {
  const newObj: any = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
      newObj[newKey] = obj[key];
    }
  }
  return newObj;
};

export const UserContent: React.FC<UserContentProps> = ({
  OptionsBrandedActiveSP,
  handleOpenDialogAssingBond,
  handleOpenDialogEditBond,
  OptionsBrandedActiveFeeCursos,
  setFormsCourses,
  handleOpenDialogCourses,
  setTitleDialogMethodsPay,
  handleOpenDialogAsingLessons,
  handleOpenDialogAsingAssisteds,
  itemsChat,
}: UserContentProps) => {
  const { id } = useParams();
  console.debug("ID DEL USER CONTENT");
  console.debug({ id });

  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const [branchId, setBranchId] = useState(0);

  const [branchInfo, setBranchInfo] = useState<Branch>(null);

  useEffect(() => {
    if (user) {
      setBranchInfo(toSnakeCase(user.branch));
    }
  }, [user]);

  useEffect(() => {
    if (branchInfo) {
      //console.log("Info de la branch:", branchInfo)
    }
  }, [branchInfo]);

  const [ToggleStatus, setToggleStatus] = useState(true);
  const [month, setMonth] = useState(DateTime.now().toFormat("yyyy-MM"));
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedState, setSelectedState] = useState({ id: "", name: "" });
  const [optionsStateApi, setOptionsStateApi] = useState([]);
  //STATE PARA DARLE FORMATO A LOS PAISES
  const [optionsCountryApi, setOptionsCountryApi] = useState([]);
  // STATE PARA GUARDAR EL PAIS SELECCIONADO
  const [SelectedCountry, SetSelectedCountry] = useState([]);
  const [optionsGyms, setOptionsGyms] = useState([]);
  const [gymId, setgymId] = useState(0);
  const [optionsBranchs, setOptionsBranchs] = useState([]);
  //STATE FIRMA
  const [modalFirma, setModalFirma] = useState(false);
  const sigCanvas = useRef(null);
  const [firma, setFirma] = useState(null);
  //state delete
  const [openDelete, setOpenDelete] = useState(false);

  //STATE RESET PASSWORD
  const [resetPassword, setResetPassword] = useState(false);
  const formikRef = useRef(null);
  const formikUserRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const [openMethodsPay, setOpenMethodsPay] = useState(false);
  const handleOpenMethodsPay = () => setOpenMethodsPay(!openMethodsPay);

  const [stripeSetupIntent, stripeSetupIntentResult] =
    useLazyStripeSetupIntentQuery();

  const [selectedProject, setSelectedProject] = useState(null);
  const handleSelectProject = (project) => {
    if (selectedProject === project.name) {
      setSelectedProject(null);
    } else {
      setSelectedProject(project.name); // O usa un identificador único
    }
  };

  useEffect(() => {
    if (user && user.branch) {
      setBranchId(user.branch.id);
    }
  }, [user]);

  //USE STATE SELECT CALENDAR
  const [selectCalendar, setSelectCalendar] = useState("month");
  const handleViewChange = (select: string) => {
    setSelectCalendar(select);
  };

  //TABS GENERALES
  const [selectedTab, setSelectedTab] = useState(1);
  const tabs = [
    { id: 1, name: t("user.views.sections.operative_and_financial") },
    { id: 2, name: t("user.views.sections.client_fidelization") },
    { id: 3, name: t("user.views.sections.client_experience") },
  ];
  const handleTabChange = (tabId: any) => {
    setSelectedTab(tabId);
  };

  // TABS OPERATIVOS Y FINANCIEROS
  const [currenTabSelect, setCurrentTabSelect] = useState("");

  // TABS CURSOS
  const [selectedTabCursos, setSelectedTabCursos] = useState(1);
  const tabsCursos = [
    { id: 1, name: t("accounting.views.cuotas") },
    { id: 2, name: t("course.views.courses") },
    { id: 3, name: t("user.views.history") },
  ];
  const handleTabChangeCursos = (tabId: any) => {
    setSelectedTabCursos(tabId);
  };
  // OPTIONS BRANDED ACTIVE SP
  const optionsMethodsPay = [
    {
      id: 1,
      name: "Domiciliación bancaria manual",
      description: "ES0700120345030000067890",
    },
    {
      id: 2,
      name: "Efectivo",
      description: "Datafono",
    },
  ];

  //variables de prueba
  const fakeDataUserRestante = {
    createAt: "04-10-2024",
    birthday: "21-07-2004",
    sex: "Masculino",
  };
  const activity = [];

  /*
   * OPERATIONS QUERYS
   */
  const userShowData = useUserQuery({ id });
  const userQuery = useUserGetQuery({ id });
  //const dataActive = useUserActiveQuery({ id });

  const [userCompleteData, setUserCompleteData] = useState(null);
  useEffect(() => {
    if (userShowData.isSuccess) {
      setUserCompleteData(userShowData.data);
    }
  }, [userShowData]);

  const [userInfo, setUserInfo] = useState(null);
  useEffect(() => {
    if (userQuery.data) {
      setUserInfo(userQuery.data);
    }
  }, [userQuery]);

  const [updateUser, updateUserResult] = useUpdateSetUserMutation();
  const [updatePass, updatePassResult] = useUpdatePassMutation();
  const [createTag, createTagResult] = useCreateTagMutation();
  const [deleteUser, deleteUserResult] = useUserDeleteMutation();

  const [generateTicket] = useGetTicketMutation();
  const earningsMonthData = useGetEarningsMonthQuery({
    userId: id,
    branchIds: [branchId],
  });

  const GetAverageLife = useGetAverageLifeQuery({
    userId: id,
    branchIds: [branchId],
  });

  const GetTransactions = useGetTransactionsQuery({ userId: id });
  const GetPaymentMethods = useGetpaymentMethodsQuery({ userId: id });

  const [webApp] = useWebAppMutation();
  const tagMarketingQueryQuery = useTagMarketingQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  const optionsUserTags = useMemo(() => {
    return tagMarketingQueryQuery.data
      ? tagMarketingQueryQuery.data
          ?.filter((role: any) => role.type === 2)
          .map((role: any) => ({
            id: role.id,
            name: role.name,
            color: role.color,
          }))
      : [];
  }, [tagMarketingQueryQuery]);

  const optionsMarketingTags = useMemo(() => {
    return tagMarketingQueryQuery.data
      ? tagMarketingQueryQuery.data
          ?.filter((role: any) => role.type === 1)
          .map((role: any) => ({
            id: role.id,
            name: role.name,
            color: role.color,
          }))
      : [];
  }, [tagMarketingQueryQuery]);

  // console.log("que me trae el user", userQuery.data);
  // WEB APP
  const handleRedirect = async (userId: number) => {
    try {
      const res = await webApp({ id: userId }).unwrap();
      window.open(res.redirect_url, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error("Error generando el token:", err);
    }
  };

  useEffect(() => {
    if (userQuery.data) {
      setBranchInfo(toSnakeCase(userQuery.data.branch));
    }
  }, [userQuery]);

  const projects = useMemo(() => {
    if (!branchInfo) return [];

    return [
      {
        name: t("accounting.views.cuotas"),
        initials: "CU",
        function: () => {
          if (currenTabSelect === "CU") {
            setCurrentTabSelect("");
          } else {
            setCurrentTabSelect("CU");
          }
        },
        hide: branchInfo.customer_to_gym_subscription,
      },
      {
        name: t("calendar.lessons"),
        initials: "AD",
        function: () => {
          if (currenTabSelect === "AD") {
            setCurrentTabSelect("");
          } else {
            setCurrentTabSelect("AD");
          }
        },
        hide: branchInfo.lesson_module,
      },
      {
        name: t("assisted.views.title"),
        initials: "SP",
        function: () => {
          if (currenTabSelect === "SP") {
            setCurrentTabSelect("");
          } else {
            setCurrentTabSelect("SP");
          }
        },
        hide: branchInfo.assisted_module,
      },
      {
        name: t("slots.views.title"),
        initials: "ES",
        function: () => {
          if (currenTabSelect === "ES") {
            setCurrentTabSelect("");
          } else {
            setCurrentTabSelect("ES");
          }
        },
        hide: branchInfo.slots,
      },
      {
        name: t("course.views.courses"),
        initials: "CR",
        function: () => {
          if (currenTabSelect === "CR") {
            setCurrentTabSelect("");
          } else {
            setCurrentTabSelect("CR");
          }
        },
        hide: branchInfo.course_module,
      },
      {
        name: t("kpi.views.Tienda"),
        initials: "T",
        function: () => {
          if (currenTabSelect === "T") {
            setCurrentTabSelect("");
          } else {
            setCurrentTabSelect("T");
          }
        },
        hide: branchInfo.store,
      },
    ];
  }, [branchInfo, currenTabSelect, t]);

  const [userTags, setUserTags] = useState([]);
  const [marketingTags, setMarketingTags] = useState([]);
  const [userTagsSave, setUserTagsSave] = useState([]);
  const [marketingTagsSave, setMarketingTagsSave] = useState([]);

  useEffect(() => {
    const tagMarketingIds =
      userQuery.data?.tagMerketing?.split(",").map(Number) || [];
    const tagUserIds = userQuery.data?.tagUsers?.split(",").map(Number) || [];

    // Tags seleccionados de marketing (type 1)
    const selectedMarketing = optionsMarketingTags.filter((option) =>
      tagMarketingIds.includes(Number(option.id))
    );
    setMarketingTags(selectedMarketing);

    // Tags seleccionados de usuario (type 2)
    const selectedUsers = optionsUserTags.filter((option) =>
      tagUserIds.includes(Number(option.id))
    );
    setUserTags(selectedUsers);
  }, [tagMarketingQueryQuery]);

  function getUniqueTags(
    currentTagsString: string,
    savedTags: { id: number }[]
  ) {
    // Convertimos la string "2" a [2]
    const currentIds = (currentTagsString || "")
      .split(",")
      .map((id) => parseInt(id))
      .filter((id) => !isNaN(id));

    const savedIds = savedTags.map((tag) => tag.id);

    const currentSet = new Set(currentIds);
    const savedSet = new Set(savedIds);

    // Caso: son iguales → no se guarda nada
    const areEqual =
      currentIds.length === savedIds.length &&
      currentIds.every((id) => savedSet.has(id));

    if (areEqual) return [];

    // Si hay valores en current que no están en saved → debemos incluirlos
    const missingInSaved = currentIds
      .filter((id) => !savedSet.has(id))
      .map((id) => ({ id }));

    // Si hay nuevos valores no presentes en current → también los agregamos
    const newInSaved = savedTags.filter((tag) => !currentSet.has(tag.id));

    return [...missingInSaved, ...newInSaved];
  }

  useEffect(() => {
    const saveTags = async () => {
      try {
        const filteredUserTags = getUniqueTags(
          userQuery.data?.tagUsers,
          userTagsSave
        );
        const filteredMarketingTags = getUniqueTags(
          userQuery.data?.tagMerketing,
          marketingTagsSave
        );

        if (userTagsSave.length > 0) {
          await createTag({
            user_id: id,
            type: 2,
            selectedValues: filteredUserTags.map((opt) => opt.id),
          }).unwrap();
          setUserTagsSave([]); // limpiar
        }

        if (marketingTagsSave.length > 0) {
          await createTag({
            user_id: id,
            type: 1,
            selectedValues: filteredMarketingTags.map((opt) => opt.id),
          }).unwrap();
          setMarketingTagsSave([]); // limpiar
        }
      } catch (error) {
        console.error("Error al crear tags:", error);
      }
    };

    saveTags();
  }, [userTagsSave, marketingTagsSave]);

  useEffect(() => {
    if (createTagResult.isSuccess) {
      toasts.success(
        "Cambio exitoso",
        "La etiqueta ha sido cambiada correctamente"
      );
    }

    if (createTagResult.isError) {
      toasts.danger(
        "Error al cambiar",
        "Ha ocurrido un error al cambiar la etiqueta"
      );
    }
  }, [createTagResult]);

  useEffect(() => {
    if (deleteUserResult.isSuccess) {
      toasts.success(
        "Eliminación exitosa",
        "La eliminación del usuario fue exitosa"
      );
    }

    if (deleteUserResult.isError) {
      toasts.danger(
        "Error al eliminar",
        "Ha ocurrido un error al eliminar el usuario"
      );
    }
  }, [deleteUserResult]);

  //INGRESOS
  const [onRevenueUsers, setOnRevenueUsers] = useState(false);

  useEffect(() => {
    if (!onRevenueUsers) return;

    const systemLanguage: Language = navigator.language.slice(0, 2) as Language;
    const selectedMonths = months[systemLanguage] || months["en"];

    if (earningsMonthData?.data && Array.isArray(earningsMonthData.data)) {
      const transformed: any[] = [];

      earningsMonthData.data.forEach((item: any) => {
        item.data.forEach((value: number, index: number) => {
          if (!transformed[index]) {
            transformed[index] = { month: selectedMonths[index] };
          }
          transformed[index][item.fee] = value;
        });
      });

      const currency = ""; // define si lo necesitas

      // Esperar al siguiente "tick" para asegurarte de que el div ya se ha montado
      setTimeout(() => {
        const chartContainer = document.getElementById(
          "chart_earnings_total_income"
        );
        if (chartContainer) {
          createEarningsTotalIncomeChart(
            transformed,
            colorsKpi,
            currency,
            earningsMonthData
          );
        } else {
          console.warn("Chart container not found!");
        }
      }, 0);
    }
  }, [earningsMonthData, onRevenueUsers]);

  const handleTicket = async (id: number) => {
    try {
      const pdfBlob = await generateTicket(id).unwrap();
      const url = window.URL.createObjectURL(pdfBlob);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error al obtener el ticket:", error);
    }
  };

  const [factura, setFactura] = useState(false);

  //metodos de pago
  const [MethodsPay, setMethodsPay] = useState(false);

  function createEarningsTotalIncomeChart(
    data: any,
    colors: any,
    currency: string,
    dataGlobal: any
  ) {
    am5.ready(() => {
      console.log("Initializing chart...");
      const root = initializeAmChart("chart_earnings_total_income");
      root.setThemes([am5themes_Animated.new(root)]);

      const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: false,
          panY: false,
          wheelX: undefined,
          wheelY: undefined,
          paddingLeft: 0,
          paddingRight: 0,
          layout: root.verticalLayout,
        })
      );

      if (root._logo) {
        root._logo.dispose();
      }

      const legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.p50,
          x: am5.p50,
          height: am5.percent(20),
          width: am5.percent(90),
          layout: am5.GridLayout.new(root, { fixedWidthGrid: true }),
          verticalScrollbar: am5.Scrollbar.new(root, {
            orientation: "vertical",
          }),
        })
      );

      legend.labels.template.setAll({
        fontSize: 12,
        fontWeight: "400",
        fill: am5.color(0x6b7280),
      });

      const xRenderer = am5xy.AxisRendererX.new(root, {
        cellStartLocation: 0.2,
        cellEndLocation: 0.9,
        minGridDistance: 30,
        minorGridEnabled: true,
      });

      const xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: "month",
          renderer: xRenderer,
          tooltip: am5.Tooltip.new(root, {}),
        })
      );

      xRenderer.grid.template.setAll({ location: 1, visible: false });
      xAxis.data.setAll(data);

      xAxis.get("renderer").labels.template.setAll({
        fontSize: "10px",
        fill: am5.color(0x6b7280),
      });

      const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          calculateTotals: true,
          min: 0,
          extraMax: 0.1,
          renderer: am5xy.AxisRendererY.new(root, { strokeOpacity: 0.1 }),
        })
      );

      yAxis.get("renderer").labels.template.setAll({
        fontSize: "10px",
        fill: am5.color(0x6b7280),
      });

      function makeSeries(
        name: string,
        fieldName: string,
        showTotal: boolean,
        color: string
      ) {
        const series = chart.series.push(
          am5xy.ColumnSeries.new(root, {
            name: name,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: fieldName,
            categoryXField: "month",
            stacked: true,
            stroke: am5.color(0xffffff),
          })
        );

        series.columns.template.setAll({
          tooltipText: `{name}, {categoryX}: {valueY} ${currency}`,
          width: am5.percent(90),
          fill: am5.color(color),
          tooltipY: 0,
          strokeOpacity: 0,
          strokeWidth: 0,
        });

        if (showTotal) {
          series.columns.template.setAll({ fillOpacity: 0, strokeOpacity: 0 });

          series.bullets.push((root: any, series: any, dataItem: any) => {
            if (dataItem.get("valueYTotal") !== 0) {
              return am5.Bullet.new(root, {
                locationY: 0.5,
                sprite: am5.Label.new(root, {
                  text: "{valueYTotal}",
                  fill: am5.color(0x000000),
                  centerY: am5.p100,
                  centerX: am5.p50,
                  populateText: true,
                  fontSize: "0.8rem",
                }),
              });
            }
          });
        }

        series.data.setAll(data);
        series.appear();

        if (!showTotal) {
          legend.data.push(series);
        }
      }

      dataGlobal.data.forEach((item: any, index: number) => {
        makeSeries(item.fee, item.fee, false, colors[index]);
      });
      makeSeries("", "none", true, "#000000");

      setTimeout(() => {
        // setIsLoading(false);
      }, 1000);

      chart.appear(1000, 100);
      configureExporting(root, data);
    });
  }

  const rolesQuery = useRolesQuery(
    { branchId: branchId },
    { skip: branchId <= 0 }
  );

  useEffect(() => {
    if (userQuery.isError) {
      toasts.info(
        "Error",
        "No se pudo consultar, el usuario, inténtalo de nuevo."
      );
      navigate("/users");
    }
  }, [userQuery]);

  const roleOptions = useMemo(() => {
    return rolesQuery.data
      ?.filter((role: any) => role.name === "Client")
      .map((role: any) => ({
        id: role.name,
        name: role.name,
      }));
  }, [rolesQuery]);

  const {
    data: states,
    isLoading: isLoadingStates,
    isError: isErrorStates,
  } = useGetAllStatesQuery({});

  const {
    data: countries,
    isLoading: isLoadingCountries,
    isError: isErrorCountries,
  } = useGetAllCountriesQuery({});

  const gymsByAccessUserQuery = useGymsByAccessUserQuery({});
  const [changeStateUser, changeStateUserResult] = useStateUserMutation();
  const [fetchBranchs] = useFetchBranchsMutation();

  useEffect(() => {
    // Verifica que no esté cargando y que no haya errores
    if (
      !isLoadingCountries &&
      !isErrorCountries &&
      countries &&
      countries.length > 0
    ) {
      // Mapea y transforma los datos de los países
      const arrayCountries = countries.map((country) => ({
        id: country.name.common,
        name: country.name.common,
        code: country.cca2,
      }));

      // agregar un país por defecto
      arrayCountries.unshift({ id: "", name: "Selecciona un país", code: "" });

      // Actualiza el estado con los países formateados
      setOptionsCountryApi(arrayCountries);

      // Selecciona el primer país por defecto, si aún no hay uno seleccionado
      if (!SelectedCountry.length) {
        SetSelectedCountry(arrayCountries[0]);
      }
    }

    // Manejamos los errores
    if (isErrorCountries) {
      console.log("ERROR EN LOS COUNTRIES");
    }
  }, [countries, isLoadingCountries, isErrorCountries]);

  useEffect(() => {
    if (user && gymsByAccessUserQuery.isSuccess) {
      let objetCompanies = {};
      const arrayCompanies = [];
      for (let i = 0; i < gymsByAccessUserQuery.data.length; i++) {
        objetCompanies = {
          id: gymsByAccessUserQuery.data[i].id,
          name: gymsByAccessUserQuery.data[i].name,
        };
        arrayCompanies.push(objetCompanies);
      }

      setgymId(user.branch.gymId);
      setOptionsGyms(arrayCompanies);
    }
  }, [gymsByAccessUserQuery, user]);

  useEffect(() => {
    const fetchBranchsData = async () => {
      const responseBranchs = await fetchBranchs({
        limit: 100,
        gymId: gymId,
      }).unwrap();
      const arrayBranchs = [];
      let objetBranchs = {};
      for (let i = 0; i < responseBranchs.data.length; i++) {
        objetBranchs = {
          id: responseBranchs.data[i].id,
          name: responseBranchs.data[i].branch,
          gym_id: responseBranchs.data[i].gym_id,
        };
        arrayBranchs.push(objetBranchs);
      }

      setOptionsBranchs(arrayBranchs);
    };

    if (gymId !== 0) {
      fetchBranchsData();
    }
  }, [gymId]);

  useEffect(() => {
    if (updateUserResult.isSuccess) {
      toasts.success(
        "Registro actualizado",
        "El usuario ha sido actualizado correctamente"
      );
    }

    if (updateUserResult.isError) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar el usuario"
      );
    }
  }, [updateUserResult]);

  const optionsSex = [
    { id: "Hombre", name: t("user.views.man") },
    { id: "Mujer", name: t("user.views.female") },
  ];

  //FUNCTION FIRMA
  const [dataFirm, dataFirmResult] = useFirmaContracMutation();

  const handleSave = async () => {
    if (!sigCanvas.current) return;

    const dataUrl = sigCanvas.current.toDataURL("image/png"); // Captura firma en base64
    setFirma(dataUrl);

    const userId = id;

    const payload = {
      sign: dataUrl,
      user: userId,
    };

    try {
      const response = await dataFirm(payload).unwrap(); // dataFirm viene de RTK Query
      setModalFirma(false);
      console.log("Firma enviada con éxito:", response);
    } catch (error) {
      console.error("Error al enviar la firma:", error);
    }
  };

  useEffect(() => {
    if (dataFirmResult.isSuccess) {
      toasts.success("Cambio exitoso", "Firma guardada correctamente");
    }

    if (dataFirmResult.isError) {
      toasts.danger(
        "Error al cambiar",
        "Ha ocurrido un error al guardar la firma"
      );
    }
  }, [dataFirmResult]);

  // Limpiar firma
  const handleClear = () => {
    sigCanvas.current.clear();
    setFirma(null);
  };

  const [idBranch, setIdBranch] = useState(0);

  useEffect(() => {
    if (userQuery.data) {
      setToggleStatus(userQuery.data.active);
      setIdBranch(userQuery.data.branch.id);
    }
  }, [userQuery]);
  //END OPERATIONS QUERYS

  // Logic for Fees asign
  const [openDialogAsingFee, setOpenDialogAsingFee] = useState(false);
  const handleOpenDialogAsingFee = () => {
    //setCurrentFee(null)
    setOpenDialogAsingFee(!openDialogAsingFee);
  };

  useEffect(() => {
    if (changeStateUserResult.isSuccess) {
      toasts.success(
        "Cambio exitoso",
        "El estado del usuario ha sido cambiado correctamente"
      );
    }

    if (changeStateUserResult.isError) {
      toasts.danger(
        "Error al cambiar",
        "Ha ocurrido un error al cambiar el estado del usuario"
      );
    }
  }, [changeStateUserResult]);

  useEffect(() => {
    if (updatePassResult.isSuccess) {
      toasts.success(
        "Cambio exitoso",
        "La contraseña ha sido cambiada correctamente"
      );
    }

    if (updatePassResult.isError) {
      toasts.danger(
        "Error al cambiar",
        "Ha ocurrido un error al cambiar la contraseña"
      );
    }
  }, [updatePassResult]);

  const passwordSchema = Yup.object().shape({
    new_password: Yup.string().required("La contraseña es requerida"),
  });

  return (
    <div className="mx-auto max-w-full px-2 py-4 sm:px-2 lg:px-4">
      <div className="pl-2 mx-auto grid max-w-full grid-cols-1 grid-rows-1 items-start  gap-y-8 lg:mx-0 lg:max-w-none md:grid-cols-12">
        <div className="md:col-start-10 md:row-end-1 md:col-span-3">
          <InformationPanelUser
            user={userQuery.data ? userQuery.data : {}}
            userRestante={fakeDataUserRestante}
            optionsUserTags={optionsUserTags}
            selectedOptionsUserTags={userTags}
            setDeselectedOptionsUserTags={setUserTagsSave}
            setSelectedOptionsUserTags={setUserTags}
            setDeselectedOptionsMarketingTags={setMarketingTagsSave}
            userTagsSave={userTagsSave}
            marketingTagsSave={marketingTagsSave}
            optionMarketingTags={optionsMarketingTags}
            selectedOptionMarketingTags={marketingTags}
            setSelectedOptionMarketingTags={setMarketingTags}
            onMethodsPay={() => {
              setMethodsPay(true);
            }}
            ToggleStatus={ToggleStatus}
            setToggleStatus={(user, state) => {
              changeStateUser({
                id: user,
                state,
              });
            }}
            handleEdit={() => setOpen(true)}
            handleFirma={() => setModalFirma(true)}
            handleRestPass={() => setResetPassword(true)}
            handleWebApp={() => handleRedirect(userQuery.data.id)}
            handleDelet={() => setOpenDelete(true)}
            onRevenueUsers={() => {
              setOnRevenueUsers(true);
            }}
          />
        </div>

        <Modal
          open={modalFirma}
          Close={() => setModalFirma(false)}
          tittleModal={t(
            "permissions.views.permission_user.create_edition.firmar"
          )}
          textButtonClose={t("general.cancel")}
        >
          <div className="flex flex-col items-center gap-4">
            {userQuery.data?.signPath ? (
              <div className="col-12 d-flex justify-content-center align-items-center mb-5 mt-5">
                <img
                  src={`${DOMAIN}/${userQuery.data.sign_path}`}
                  alt="Firma del usuario"
                  width="500"
                />
              </div>
            ) : (
              // Si no hay firma, muestra el área para firmar
              <div className="w-full flex flex-col items-center gap-4">
                {/* Aquí iría la lógica para firmar */}
                <SignatureCanvas
                  ref={sigCanvas}
                  penColor="black"
                  canvasProps={{
                    className:
                      "border border-gray-300 w-full max-w-[500px] h-[250px] rounded",
                  }}
                />
              </div>
            )}

            {/* Botones de acción */}
            <div className="flex gap-4">
              {!userQuery.data?.signPath && (
                <>
                  <button
                    onClick={handleSave}
                    className="text-primary-600 hover:text-primary-900"
                  >
                    {t("general.save")}
                  </button>
                  <button
                    onClick={handleClear}
                    className="text-primary-600 hover:text-primary-900"
                  >
                    {t("user.views.clean")}
                  </button>
                </>
              )}
            </div>
          </div>
        </Modal>

        <div className="-mx-4 pl-2  pr-4 sm:pl-0 sm:mx-0 sm:rounded-lg sm:pr-4 sm:pb-14 md:col-span-9 md:row-span-2 md:row-end-2 ">
          <TabsUser
            tabs={tabs}
            selectedTab={selectedTab}
            handleTabChange={handleTabChange}
          />

          {branchInfo ? (
            <>
              {selectedTab === 1 ? (
                <>
                  <div className="mt-6">
                    <CardsGestion
                      options={projects}
                      handleSelectProject={handleSelectProject}
                      selectedProject={selectedProject}
                    />
                    {currenTabSelect === "CU" ? (
                      <>
                        <FeesAssignment />
                      </>
                    ) : null}
                    {currenTabSelect === "AD" ? (
                      <>
                        <LessonsAssignment branch_id={idBranch} />
                      </>
                    ) : null}
                    {currenTabSelect === "SP" ? (
                      <>
                        <AssistedsAssignment
                          handleOpenDialogAsingAssisteds={
                            handleOpenDialogAsingAssisteds
                          }
                          handleOpenDialogAssingBond={
                            handleOpenDialogAssingBond
                          }
                          OptionsBrandedActiveSP={OptionsBrandedActiveSP}
                          userSelected={userQuery.data ?? null}
                          branch_id={idBranch}
                        />
                      </>
                    ) : null}
                    {currenTabSelect === "ES" ? (
                      <>
                        <SlotsAssignment
                          handleOpenDialogAsingAssisteds={
                            handleOpenDialogAsingAssisteds
                          }
                          handleOpenDialogAssingBond={
                            handleOpenDialogAssingBond
                          }
                          handleOpenDialogEditBond={handleOpenDialogEditBond}
                          userShowData={userShowData.data ?? null}
                          userSelected={userQuery.data ?? null}
                          branch_id={idBranch}
                        />
                      </>
                    ) : null}
                    {currenTabSelect === "CR" ? (
                      <>
                        <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10  mb-5 md:mb-3">
                          {t("course.views.courses")}
                        </h1>
                        <TabsUser
                          tabs={tabsCursos}
                          selectedTab={selectedTabCursos}
                          handleTabChange={handleTabChangeCursos}
                          button={
                            <ButtonSoft
                              text={t("user.views.manage_courses")}
                              size="large"
                            />
                          }
                        />
                        {selectedTabCursos === 1 ? (
                          <>
                            <TableListCuotasCursosUsers
                              cursos={userShowData.data.feesCourse ?? []}
                              user={userQuery.data}
                              titleBranded={t("bond.views.assign")}
                              titleBrandedActiveFee={t("user.views.actions")}
                              OptionsBrandedActiveFee={
                                OptionsBrandedActiveFeeCursos
                              }
                              onAssingFee={() => handleOpenDialogAsingFee}
                            />
                          </>
                        ) : (
                          <>
                            {selectedTabCursos === 2 ? (
                              <>
                                <TableListCursosUsers
                                  onInscribe={() => {
                                    setFormsCourses(1);
                                    handleOpenDialogCourses();
                                  }}
                                  onUnsubscribe={() => {
                                    setFormsCourses(2);
                                    handleOpenDialogCourses();
                                  }}
                                  cursos={userShowData.data.courses ?? []}
                                  fees={userShowData.data.fees ?? []}
                                />
                              </>
                            ) : (
                              <>
                                {selectedTabCursos === 3 ? (
                                  <>
                                    <ListHistorial history={activity} />
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}{" "}
                          </>
                        )}
                      </>
                    ) : null}
                    {currenTabSelect === "T" ? (
                      <>
                        <StoreAssignment
                          branch_id={idBranch}
                          userShowData={userShowData.data ?? null}
                        />
                      </>
                    ) : null}
                  </div>
                </>
              ) : null}
              {selectedTab === 2 ? <LoyaltyUser /> : null}
              {selectedTab === 3 && (
                <CustomerExperiencie
                  userId={id}
                  user={userShowData?.data?.user}
                  trainingPlan={
                    userShowData.data ? userShowData.data.progressArr : []
                  }
                  nutritionPlan={
                    userShowData.data ? userShowData.data.progressArr : []
                  }
                />
              )}
            </>
          ) : null}
        </div>

        <div className="md:col-start-10 md:col-span-3">
          <h2 className="text-sm font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-6">
            {t("chat.app.messages")}
          </h2>
          <div className="mt-6 h-80 overflow-y-auto">
            <ListChatUser items={itemsChat} />
          </div>
        </div>
      </div>

      <Formik
        innerRef={formikUserRef}
        enableReinitialize
        validationSchema={userValidationSchema}
        initialValues={{
          ...userInitialValues,
          name: userQuery?.data?.name || "",
          role: userQuery?.data?.role || "",
          phone: userQuery?.data?.phone || "",
          email: userQuery?.data?.email || "",
          address: userQuery?.data?.address || "",
          country: userQuery?.data?.country || "",
          state: userQuery?.data?.state || "",
          city: userQuery?.data?.city || "",
          postal_code: userQuery?.data?.postal_code || "",
          dni: userQuery?.data?.dni || "",
          occupation: userQuery?.data?.occupation || "",
          occupation_description: userQuery?.data?.occupation_description || "",
          company: userQuery?.data?.company || "",
          birthday: userQuery?.data?.birthday || "",
          sex: userQuery?.data?.sex || "",
          objective: userQuery?.data?.objective || "",
          terms: userQuery?.data?.terms || false,
          accept_clauses: userQuery?.data?.accept_clauses || true,
          sufficiently_informed: userQuery?.data?.sufficiently_informed || true,
          receive_communications:
            userQuery?.data?.receive_communications || false,
          image_rights: userQuery?.data?.image_rights || false,
          is_chat_responsible: userQuery?.data?.is_chat_responsible || false,
          gym_id: user?.branch?.gymId || "",
          branch_id: user?.branch?.id || "",
          profile_avatar: userQuery?.data?.avatar || null,
        }}
        onSubmit={async (values, formikHelpers) => {
          try {
            console.log("Valores del formulario:", values);

            const userId = userQuery?.data?.id;
            if (!userId) {
              console.error("Error: ID del usuario no disponible.");
              return;
            }

            const formToSend = new FormData();
            Object.entries(values).forEach(([key, value]) => {
              formToSend.append(key, value);
            });

            await updateUser({ id: userId, userData: values }).unwrap();

            formikHelpers.resetForm();
            setOpen(false);
          } catch (error) {
            console.error("Error al actualizar el usuario:", error);
          }
        }}
      >
        {({
          handleChange,
          setFieldValue,
          values,
          handleSubmit,
          errors,
          isValid,
          resetForm,
          touched,
        }) => {
          useEffect(() => {
            if (!isLoadingStates && !isErrorStates && states?.length > 0) {
              const statesFilterByCode = states.filter(
                (state) => state.countryCode === values.country.code
              );

              const arrayStates = statesFilterByCode.map((state) => ({
                id: state.name,
                name: state.name,
              }));

              if (arrayStates.length > 0) {
                setOptionsStateApi(arrayStates);
                if (!selectedState) setSelectedState(arrayStates[0]);
              } else {
                setOptionsStateApi([{ id: "NO TIENE", name: "Sin estados" }]);
              }
            }
          }, [states, isLoadingStates, isErrorStates, values.country]);

          return (
            <DialogCreate
              open={open}
              setOpen={setOpen}
              tittle={t("user.views.profile")}
              subTittle={t("user.views.info_user")}
              tittleButtonCreate={t("general.edit")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={() => {
                console.log("values", values);

                console.log("errors", errors);
                handleSubmit();
                if (formikUserRef.current) {
                  formikUserRef.current.submitForm();
                }
              }}
              OnclickCancel={() => {
                setOpen(false);
                resetForm();
              }}
              isLoading={updateUserResult.isLoading}
              // acceptDisabled={updateUserResult.isLoading || !isValid}
              cancelDisabled={updateUserResult.isLoading}
            >
              <Form>
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("user.views.profil_user")}
                          </h2>
                        </div>
                      </div>

                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputFile
                            name="profile_avatar"
                            id="profile_avatar"
                            label={t("user.views.avatar")}
                            spanButton={t("user.views.avatar")}
                            description={t("user.views.avatar")}
                            selectedImage={values.profile_avatar}
                            onFileChange={(file) =>
                              setFieldValue("profile_avatar", file)
                            }
                            onRemoveImage={() =>
                              setFieldValue("profile_avatar", null)
                            }
                            tittleDelete={t("general.delete_image")}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("user.views.name")}
                            span={t("general.mandatory")}
                            id="name"
                            name="name"
                            type="text"
                            placeholder={t("user.views.name_last")}
                            value={values.name}
                            onChange={handleChange}
                            error={touched.name && !!errors.name}
                            textError={errors.name}
                          />
                        </div>
                        <div className="col-span-full">
                          {rolesQuery.data && (
                            <Select
                              name="role"
                              span={t("general.mandatory")}
                              error={touched.role && !!errors.role}
                              textError={touched.role && errors.role}
                              selected={
                                values.role
                                  ? roleOptions.find(
                                      (option) => option.id === values.role
                                    )
                                  : null
                              }
                              setSelected={(value) =>
                                setFieldValue("role", value.id)
                              }
                              options={roleOptions}
                              tittle={t("user.views.role")}
                            />
                          )}
                        </div>
                        <div className="col-span-full">
                          <InputWithLeadingIcon
                            label={t("user.views.phone")}
                            span={t("general.optional")}
                            id="phone"
                            name="phone"
                            type="text"
                            placeholder={t("user.views.phone")}
                            value={values.phone}
                            onChange={handleChange}
                            error={touched.phone && !!errors.phone}
                            textError={touched.phone && errors.phone}
                            icon={
                              <FontAwesomeIcon
                                icon={faPhone}
                                className="h-4 w-4 text-gray-400"
                              />
                            }
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithLeadingIcon
                            label={t("user.views.email")}
                            span={t("general.mandatory")}
                            id="email"
                            name="email"
                            type="email"
                            placeholder={t("user.views.email")}
                            value={values.email}
                            onChange={handleChange}
                            error={touched.email && !!errors.email}
                            textError={touched.email && errors.email}
                            icon={
                              <FontAwesomeIcon
                                icon={faAt}
                                className="h-4 w-4 text-gray-400"
                              />
                            }
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("user.views.address")}
                            span={t("general.optional")}
                            id="address"
                            name="address"
                            type="text"
                            placeholder={t("user.views.address")}
                            value={values.address}
                            onChange={handleChange}
                            error={touched.address && !!errors.address}
                            textError={touched.address && errors.address}
                          />
                        </div>
                        <div className="col-span-full">
                          <SelectCountry
                            span={t("general.optional")}
                            selected={values.country}
                            setSelected={(value) =>
                              setFieldValue("country", value)
                            }
                            options={optionsCountryApi}
                            tittle={t("user.views.country")}
                          />
                        </div>
                        <div className="col-span-full">
                          <Select
                            span={t("general.optional")}
                            selected={values.state}
                            setSelected={(value) =>
                              setFieldValue("state", value)
                            }
                            options={optionsStateApi}
                            tittle={t("user.views.state")}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("user.views.city")}
                            span={t("general.optional")}
                            id="city"
                            name="city"
                            type="text"
                            placeholder={t("user.views.city")}
                            value={values.city}
                            onChange={handleChange}
                            error={touched.city && !!errors.city}
                            textError={touched.city && errors.city}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("user.views.postal_code")}
                            span={t("general.optional")}
                            id="postal_code"
                            name="postal_code"
                            type="text"
                            placeholder={t("user.views.postal_code")}
                            value={values.postal_code}
                            onChange={handleChange}
                            error={touched.postal_code && !!errors.postal_code}
                            textError={
                              touched.postal_code && errors.postal_code
                            }
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("user.views.dni")}
                            span={t("general.optional")}
                            id="dni"
                            name="dni"
                            type="text"
                            placeholder={t("user.views.dni")}
                            value={values.dni}
                            onChange={handleChange}
                            error={touched.dni && !!errors.dni}
                            textError={touched.dni && errors.dni}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("user.views.occupation")}
                            span={t("general.optional")}
                            id="occupation"
                            name="occupation"
                            type="text"
                            placeholder={t("user.views.occupation")}
                            value={values.occupation}
                            onChange={handleChange}
                            error={touched.occupation && !!errors.occupation}
                            textError={touched.occupation && errors.occupation}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("user.views.business")}
                            span={t("general.optional")}
                            id="company"
                            name="company"
                            type="text"
                            placeholder={t("user.views.business")}
                            value={values.company}
                            onChange={handleChange}
                            error={touched.company && !!errors.company}
                            textError={touched.company && errors.company}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("user.views.birthday")}
                            span={t("general.mandatory")}
                            id="birthday"
                            name="birthday"
                            type="date"
                            placeholder={t("user.views.birthday")}
                            value={values.birthday}
                            onChange={handleChange}
                            error={touched.birthday && !!errors.birthday}
                            textError={touched.birthday && errors.birthday}
                          />
                        </div>
                        <div className="col-span-full">
                          <Select
                            name="sex"
                            span={t("general.mandatory")}
                            error={touched.sex && !!errors.sex}
                            textError={touched.sex && errors.sex}
                            selected={optionsSex.find(
                              (option) => option.id === values.sex
                            )}
                            setSelected={(value) =>
                              setFieldValue("sex", value.id)
                            }
                            options={optionsSex}
                            tittle={t("user.views.sex")}
                          />
                        </div>
                        <div className="col-span-full">
                          <Select
                            span={t("general.optional")}
                            selected={[
                              {
                                id: "healt",
                                name: t("progress.objective.healt"),
                              },
                              {
                                id: "definition",
                                name: t("progress.objective.definition"),
                              },
                              {
                                id: "hypertrophy",
                                name: t("progress.objective.hypertrophy"),
                              },
                            ].find((opt) => opt.id === values.objective)}
                            setSelected={(value) =>
                              setFieldValue("objective", value.id)
                            }
                            options={[
                              {
                                id: "healt",
                                name: t("progress.objective.healt"),
                              },
                              {
                                id: "definition",
                                name: t("progress.objective.definition"),
                              },
                              {
                                id: "hypertrophy",
                                name: t("progress.objective.hypertrophy"),
                              },
                            ]}
                            tittle={t("user.views.objective")}
                          />
                        </div>
                        <div className="col-span-full">
                          <div className="relative flex items-start">
                            <div className="flex h-6 items-center">
                              <input
                                checked={values.terms}
                                onChange={handleChange}
                                name="terms"
                                id="terms"
                                type="checkbox"
                                aria-describedby=""
                                className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                              />
                            </div>
                            <div className="ml-3 text-sm leading-6">
                              <label
                                htmlFor="terms"
                                className="font-medium text-gray-900 mr-2"
                              >
                                {t("user.views.accept_term")}
                              </label>
                              <a
                                href="https://fitmewise.com/terminos-y-condiciones-de-uso/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary-600 hover:text-primary-900"
                              >
                                {t("user.views.ready_more")}
                              </a>
                            </div>
                          </div>

                          {touched.sex && !!errors.sex && (
                            <p className={`mt-1 text-sm text-red-600`}>
                              {touched.sex && errors.sex}
                            </p>
                          )}
                        </div>
                        <div className="col-span-full">
                          <Select
                            name="gym_id"
                            span={t("general.mandatory")}
                            error={touched.gym_id && !!errors.gym_id}
                            textError={touched.gym_id && errors.gym_id}
                            selected={
                              values.gym_id
                                ? optionsGyms.find(
                                    (option) => option.id === values.gym_id
                                  )
                                : null
                            }
                            setSelected={(value) => {
                              setFieldValue("gym_id", value.id);
                              setgymId(value.id);
                            }}
                            options={optionsGyms}
                            tittle={t("user.views.company")}
                          />
                        </div>

                        <div className="col-span-full">
                          <Select
                            name="branch_id"
                            span={t("general.mandatory")}
                            error={touched.branch_id && !!errors.branch_id}
                            textError={touched.branch_id && errors.branch_id}
                            selected={
                              values.branch_id
                                ? optionsBranchs.find(
                                    (option) => option.id === values.branch_id
                                  )
                                : null
                            }
                            setSelected={(value) =>
                              setFieldValue("branch_id", value.id)
                            }
                            options={optionsBranchs}
                            tittle={t("user.views.branch")}
                          />
                        </div>

                        <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                          <div className="relative flex items-start">
                            <div className="flex h-6 items-center">
                              <input
                                checked={true}
                                disabled={true}
                                // value={values.accept_clauses}
                                id="accept_clauses"
                                name="accept_clauses"
                                type="checkbox"
                                aria-describedby=""
                                className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600 disabled:text-primary-300 cursor-not-allowed hover:cursor-not-allowed"
                              />
                            </div>
                            <div className="ml-3 text-sm leading-6">
                              <label
                                htmlFor="accept_clauses"
                                className="font-medium text-gray-900"
                              >
                                {t("user.views.accept_clauses_norms")}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                          <div className="relative flex items-start">
                            <div className="flex h-6 items-center">
                              <input
                                checked={true}
                                disabled={true}
                                id="sufficiently_informed"
                                name="sufficiently_informed"
                                type="checkbox"
                                aria-describedby=""
                                className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600 disabled:text-primary-300 cursor-not-allowed hover:cursor-not-allowed"
                              />
                            </div>
                            <div className="ml-3 text-sm leading-6">
                              <label
                                htmlFor="sufficiently_informed"
                                className="font-medium text-gray-900"
                              >
                                {t("user.views.informed_participation")}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                          <div className="relative flex items-start">
                            <div className="flex h-6 items-center">
                              <input
                                checked={values.receive_communications}
                                onChange={handleChange}
                                id="receive_communications"
                                name="receive_communications"
                                type="checkbox"
                                aria-describedby=""
                                className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600"
                              />
                            </div>
                            <div className="ml-3 text-sm leading-6">
                              <label
                                htmlFor="receive_communications"
                                className="font-medium text-gray-900"
                              >
                                {t("user.views.receive_communications")}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="col-span-full grid grid-cols-1 place-content-center mt-4 sm:mt-4">
                          <div className="relative flex items-start">
                            <div className="flex h-6 items-center">
                              <input
                                checked={values.image_rights}
                                onChange={handleChange}
                                id="image_rights"
                                name="image_rights"
                                type="checkbox"
                                aria-describedby=""
                                className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary-600"
                              />
                            </div>
                            <div className="ml-3 text-sm leading-6">
                              <label
                                htmlFor="image_rights"
                                className="font-medium text-gray-900"
                              >
                                {t("user.views.image_rights")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </DialogCreate>
          );
        }}
      </Formik>

      <Modal
        open={resetPassword}
        Close={() => setResetPassword(false)}
        textButtonCreate={t("general.save")}
        tittleModal={t("share.layouts.pass")}
        textButtonClose={t("general.cancel")}
        onClickCreate={() => {
          if (formikRef.current) {
            formikRef.current.submitForm();
          }
        }}
      >
        <div className="flex flex-col items-center gap-4 w-full">
          <Formik
            innerRef={formikRef}
            initialValues={{ new_password: "" }}
            validationSchema={passwordSchema}
            onSubmit={async (values, { resetForm }) => {
              try {
                setLoading(true);
                const userId = userQuery?.data?.id;
                await updatePass({ id: userId, userData: values }).unwrap();
                resetForm();
                setResetPassword(false);
              } catch (error) {
                console.error(error);
              } finally {
                setLoading(false);
              }
            }}
          >
            {() => {
              const [showPassword, setShowPassword] = useState(false);

              return (
                <Form className="w-full flex flex-col gap-4">
                  <div className="flex flex-col gap-1 w-full relative">
                    <div className="relative">
                      <Field
                        type={showPassword ? "text" : "password"}
                        name="new_password"
                        placeholder="Ingresa la nueva contraseña"
                        className="w-full p-2 pr-10 border rounded-md"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                      >
                        {showPassword ? (
                          <EyeOff size={18} />
                        ) : (
                          <Eye size={18} />
                        )}
                      </button>
                    </div>
                    <ErrorMessage
                      name="new_password"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal>

      <Modal
        open={onRevenueUsers}
        Close={() => setOnRevenueUsers(false)}
        tittleModal={t("user.views.revenue")}
        textButtonClose={t("general.cancel")}
        modalWidth="sm:max-w-6xl"
      >
        <div className="w-full flex justify-end">
          <button
            onClick={() => setFactura(true)}
            className="btn btn-fmw mr-3 mb-3 btn-invoice flex items-center gap-2 bg-primary-600 text-white px-4 py-2 rounded"
            id="btnInvoice"
          >
            <FileText size={18} className="text-white" />
            {t("subscription.views.invoices")}
          </button>
        </div>

        {/* Contenedor con scroll si hay mucho contenido */}
        <div className="w-full max-h-[70vh] overflow-y-auto  ">
          {/* CARD: Gráfica Ingresos */}
          <div className="bg-white shadow rounded-xl p-6">
            <h3 className="text-xl font-semibold mb-4">
              {t("user.views.main_title__user_earnings")}
            </h3>
            {earningsMonthData && (
              <div
                id="chart_earnings_total_income"
                style={{ width: "100%", height: "500px" }}
              />
            )}
          </div>

          {/* HEADER ACL - CLV adaptado */}
          <div className="bg-white  flex justify-center items-center">
            <h4 className="text-xl mb-0">ACL - CLV</h4>
          </div>

          {/* KPIs: ACL - CLV */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-white shadow rounded-xl p-6 flex flex-col items-center justify-center gap-4 h-64">
              <img
                src="https://dash.fitmewise.com/images/kpis/clock.png"
                alt="clock"
                className="w-12 aspect-square"
              />
              <p className="text-center">{t("kpi.views.Tiempo_de_vida")}</p>
              <h1 className="text-primary-600 text-3xl font-bold">
                {GetAverageLife.data?.[4] ?? "--"}
              </h1>
            </div>

            <div className="bg-white shadow rounded-xl p-6 flex flex-col items-center justify-center gap-4 h-64">
              <img
                src="https://dash.fitmewise.com/images/kpis/dollar.png"
                alt="dollar"
                className="w-12"
                style={{ aspectRatio: "200 / 180" }}
              />
              <p className="text-center">{t("kpi.views.Valor_Vida")} (CLV)</p>
              <h1 className="text-primary-600 text-3xl font-bold">
                {typeof GetAverageLife.data?.[5] === "number"
                  ? GetAverageLife.data[5] === 0
                    ? "0"
                    : GetAverageLife.data[5].toFixed(2)
                  : "--"}
              </h1>
            </div>
          </div>
        </div>
      </Modal>

      <DialogCreate
        open={factura}
        setOpen={() => setFactura(false)}
        tittle={t("subscription.views.invoices")}
        tittleButtonCancel={t("user.views.accept")}
        dialogWidth="w-screen max-w-md"
        OnclickCancel={() => {
          setFactura(false);
        }}
      >
        <div className="max-h-[70vh] overflow-y-auto space-y-2 m-2">
          {GetTransactions && GetTransactions.data?.length > 0 ? (
            GetTransactions.data?.map((invoice, index) => {
              const currencyInvoice = invoice.currency?.toLowerCase() || "";

              return (
                <div
                  key={invoice.id || index}
                  className="border p-4 flex justify-between items-start rounded-md shadow-sm"
                >
                  <div className="flex flex-col">
                    <div className="flex items-center space-x-2">
                      <p className="text-sm text-gray-600">{invoice.date}</p>
                    </div>
                    <span className="text-primary-600 font-bold">
                      {t(`subscription.views.currency.${currencyInvoice}`)}{" "}
                      {invoice.amount}
                    </span>
                  </div>

                  <div className="flex space-x-2">
                    <button
                      type="button"
                      onClick={() => handleTicket(invoice.id)}
                      className="btn btn-fmw px-3 py-1 bg-primary-600 text-white rounded"
                    >
                      TICKET
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-center text-gray-500">
              {t("subscription.views.no_invoices_to_view")}
            </p>
          )}
        </div>
      </DialogCreate>

      <DialogCreate
        open={MethodsPay}
        setOpen={() => setMethodsPay(false)}
        tittle={t("subscription.views.edit_payment_methods")}
        tittleButtonCancel={t("user.views.accept")}
        dialogWidth="w-screen max-w-md"
        OnclickCancel={() => {
          setMethodsPay(false);
        }}
      >
        <div className="max-h-[70vh] overflow-y-auto space-y-4">
          {user?.branch?.payment_card_module === 1 &&
            GetPaymentMethods.data?.card && (
              <div className="border p-4 flex gap-4 rounded-md shadow-sm items-start">
                <div className="text-2xl text-fmw">
                  {GetPaymentMethods.data.card.card.brand === "visa" && (
                    <i className="fa fa-cc-visa" />
                  )}
                  {GetPaymentMethods.data.card.card.brand === "mastercard" && (
                    <i className="fa fa-cc-mastercard" />
                  )}
                </div>
                <div className="flex flex-col w-full">
                  <p className="font-bold uppercase mb-1">
                    {GetPaymentMethods.data.card.card.brand} -{" "}
                    {GetPaymentMethods.data.card.card.funding}
                  </p>
                  <p className="font-bold mb-2">
                    ************ {GetPaymentMethods.data.card.card.last4} -{" "}
                    {String(
                      GetPaymentMethods.data.card.card.exp_month
                    ).padStart(2, "0")}
                    /
                    {String(GetPaymentMethods.data.card.card.exp_year).padStart(
                      2,
                      "0"
                    )}
                  </p>
                </div>
                <button className="btn btn-fmw bg-primary-600 text-white px-3 py-1 rounded">
                  {t("user.views.edit")}
                </button>
              </div>
            )}

          {GetPaymentMethods.data?.sepa_debit && (
            <div className="border p-4 flex gap-4 rounded-md shadow-sm items-start">
              <div className="text-2xl text-fmw">
                <i className="fa fa-building-columns" />
              </div>
              <div className="flex flex-col w-full">
                <p className="font-bold uppercase mb-1">
                  {t("direct_debit.views.payment_method_1")} -{" "}
                  {GetPaymentMethods.data.sepa_debit.sepa_debit.bank_code}
                </p>
                <p className="font-bold mb-2">
                  **** **** ****{" "}
                  {GetPaymentMethods.data.sepa_debit.sepa_debit.last4}
                </p>
              </div>
              <button className="btn btn-fmw bg-primary-600 text-white px-3 py-1 rounded">
                {t("user.views.edit")}
              </button>
            </div>
          )}

          {user?.direct_debits && (
            <div className="border p-4 flex gap-4 rounded-md shadow-sm items-start">
              <div className="text-2xl text-fmw">
                <i className="fa fa-building-columns" />
              </div>
              <div className="flex flex-col w-full">
                <p className="font-bold uppercase mb-1">
                  {t("fees.views.payment_direct_debit_manual")}
                </p>
                <p className="font-bold mb-2">{user.direct_debits.iban}</p>
              </div>
              <button className="btn btn-fmw bg-primary-600 text-white px-3 py-1 rounded">
                {t("user.views.edit")}
              </button>
            </div>
          )}

          {/* Mostrar mensaje si no hay ninguna opción de pago */}
          {!(
            (user?.branch?.payment_card_module === 1 &&
              GetPaymentMethods.data?.card) ||
            GetPaymentMethods.data?.sepa_debit ||
            user?.direct_debits
          ) && (
            <p className="text-center text-gray-500">
              {t("user.views.no_billing_title")}
            </p>
          )}
        </div>
      </DialogCreate>

      <Modal
        open={openDelete}
        Close={() => setOpenDelete(false)}
        tittleModal={t("share.views.carefull")}
        textButtonClose={t("general.cancel")}
        textButtonCreate={t("user.views.delete")}
        onClickCreate={async () => {
          try {
            const response = await deleteUser({
              id: userQuery.data.id,
            }).unwrap();
            console.log("Usuario eliminado:", response.message);
            navigate(`/users`);
            // Puedes cerrar el modal, lanzar un toast, etc.
            setOpenDelete(false);
          } catch (error) {
            console.error("Error al eliminar usuario:", error);
          }
        }}
      >
        <div>
          <p>
            {userQuery.data?.role === "Coach" ||
            userQuery.data?.role === "Entrenador Personal"
              ? t("user.views.delete_trainer")
              : t("user.views.delete_client")}
          </p>
        </div>
      </Modal>
    </div>
  );
};
